<section class="working-trust">
  <div class="orbit-wrap">
    <img src="images/webps/arrow.png" class="orbit-arrow orbit-arrow-top" alt="" aria-hidden="true" />

    <div class="orbit-stage">
      <div class="orbit-ring ring-outer"></div>
      <div class="orbit-ring ring-mid-outer"></div>
      <div class="orbit-ring ring-mid-inner"></div>
      <div class="orbit-ring ring-inner"></div>

      <div class="orbit-dot dot-a" aria-hidden="true"></div>
      <div class="orbit-dot dot-b" aria-hidden="true"></div>
      <div class="orbit-dot dot-c" aria-hidden="true"></div>
      <div class="orbit-dot dot-d" aria-hidden="true"></div>
      <div class="orbit-dot dot-e" aria-hidden="true"></div>
      <div class="orbit-dot dot-f" aria-hidden="true"></div>
      <div class="orbit-dot dot-g" aria-hidden="true"></div>

      <div class="orbit-center">
        <h3>Trusted by</h3>
        <h2>ambitious businesses</h2>
        <p>Building smarter operations with OrderYaa ERP</p>
      </div>

      <img
        *ngFor="let person of orbitPeople"
        [src]="person.image"
        alt="Client profile"
        [class]="person.className"
      />
    </div>

    <img src="images/webps/arrow.png" class="orbit-arrow orbit-arrow-bottom" alt="" aria-hidden="true" />
  </div>

  <div class="quote-cards">
    <article class="quote-card" *ngFor="let card of quoteCards">
      <img src="images/webps/msg-icon.png" alt="" class="quote-mark" aria-hidden="true" />
      <p>{{ card.text }}</p>

      <div class="quote-author">
        <img [src]="card.image" alt="Author" />
        <div>
          <h4>{{ card.name }}</h4>
          <span>{{ card.role }}</span>
        </div>
      </div>
    </article>
  </div>
</section>
